import { render, staticRenderFns } from "./ExpenseDistribution.vue?vue&type=template&id=56f14f8c&scoped=true&"
import script from "./ExpenseDistribution.vue?vue&type=script&lang=js&"
export * from "./ExpenseDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDistribution.vue?vue&type=style&index=0&id=56f14f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f14f8c",
  null
  
)

export default component.exports